module.exports = __webpack_public_path__ + "img/cuo.d8a405e5.png";